module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Kontakt.4675dabf.jpg";